/**
 * @generated SignedSource<<a51277a591d3041c73bc83ca121b115e>>
 * @relayHash 5f08ef52a47ed3eb6b947e29e2fb0071
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/513.0.0-2025-06-02T16:47:36.215Z/LanguageDiscrepancyModalQuery

import { ConcreteRequest } from 'relay-runtime';
export type LanguageDiscrepancyModalQuery$variables = {
  locale: string;
};
export type LanguageDiscrepancyModalQuery$data = {
  readonly viewer: {
    readonly internationalCopy: {
      readonly languageDiscrepancyModal: {
        readonly description: string | null;
        readonly noThanksButton: string | null;
        readonly title: string | null;
        readonly yesContinueButton: string | null;
      } | null;
    } | null;
  };
};
export type LanguageDiscrepancyModalQuery = {
  response: LanguageDiscrepancyModalQuery$data;
  variables: LanguageDiscrepancyModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "locale",
      "variableName": "locale"
    }
  ],
  "concreteType": "InternationalCopy",
  "kind": "LinkedField",
  "name": "internationalCopy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IntlLanguageDiscrepancyModalCopy",
      "kind": "LinkedField",
      "name": "languageDiscrepancyModal",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yesContinueButton",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noThanksButton",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LanguageDiscrepancyModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LanguageDiscrepancyModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/513.0.0-2025-06-02T16:47:36.215Z/LanguageDiscrepancyModalQuery",
    "metadata": {},
    "name": "LanguageDiscrepancyModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "46822c597294d42e88d223d82250c5ec";

export default node;
